module.exports = __webpack_public_path__ + "img/account_pc_03.19021c08.png";